<template>
  <!-- 所有页面统一走 FreeToolPage 外壳(广告位 + 推荐 + upsell)。explainer 由它在动作区渲染诚实解释,
       不再是裸文字页 —— 有 SEO 流量的落地页也能吃到广告和交叉推荐,不浪费流量。 -->
  <FreeToolPage v-if="seo" :seo="seo" />
</template>

<script setup>
import { computed } from "vue";
import { useRoute, useAsyncData, navigateTo, showError, createError } from "#imports";
import { getToolSEO } from "@/settings/free-tools/seo-data";

definePageMeta({ layout: "free-tools" });

const route = useRoute();

// slug = last segment of the catch-all param array, lowercased
const slug = computed(() => {
  const parts = route.params.slug;
  // drop empty segments so a trailing slash (the app redirects to one) doesn't
  // make the last segment "" — e.g. ["image","converter","png-to-dst",""]
  const arr = (Array.isArray(parts) ? parts : parts ? [parts] : []).filter(Boolean);
  return (arr[arr.length - 1] || "").toLowerCase();
});

// resolve the per-tool SEO payload on the server (SSR) so the body is rendered
const { data: seo } = await useAsyncData(
  "free-tool-" + slug.value,
  () => getToolSEO(slug.value) ?? null,
  { watch: [slug], default: () => null }
);

// 规范路径强制:任何非规范前缀(如视频/音频配对被访问到 /image/converter/,或裸 /free-tools/<slug>/)
// 一律 301 到 getToolSEO 的唯一规范 URL,消除重复内容(nuxt#44)。
// 无循环:canonical 恒带尾斜杠(seo-data/explainer)+ 全局中间件先给 route.path 补尾斜杠 → 单跳落到不动点。
if (seo.value) {
  const canon = String(seo.value.canonical || seo.value.url || "").replace(/^https?:\/\/[^/]+/i, "");
  const canonNorm = canon && !canon.endsWith("/") ? canon + "/" : canon;
  const cur = route.path.endsWith("/") ? route.path : route.path + "/";
  if (canonNorm && canonNorm !== cur) {
    // 保留 query + hash,避免 ?tool= 深链与分析参数在 301 中丢失
    const q = route.fullPath.slice(route.path.length); // "?a=b#h" 或 ""
    await navigateTo(canonNorm + q, { redirectCode: 301 });
  }
}

if (!seo.value) {
  showError(
    createError({ statusCode: 404, statusMessage: "Tool Not Found", fatal: true })
  );
}

useFreeToolSeoHead(seo);
</script>
